import { oc } from '@orpc/contract';
import { addWeekInputSchema, weekSchema } from '../schemas/weeks.schemas.js';
export const addWeekContract = oc
    .route({
    method: 'POST',
    path: '/weeks',
    tags: ['Weeks'],
    summary: 'Append the reporting week of the Sunday after the last one (ADMIN, PM)',
})
    .input(addWeekInputSchema)
    .output(weekSchema);
//# sourceMappingURL=add-week.contract.js.map